export const REFRESH_TOKEN_CONFIG = {
  MAX_RETRIES: 1,
  TIMEOUT_MS: 30000,
  HTTP_STATUS_UNAUTHORIZED: 401,
} as const;
